import { motion } from "framer-motion";
import { formatBytes, formatDuration } from "@/lib/format-bytes";
import { PATCHES_ADMIN } from "@/constants/testIds";

// Multi-GB uploads can run for a long time on a slow admin uplink, so this
// gets its own dedicated, "does something" look - live percentage, transfer
// speed and ETA, not just a bare bar - rather than the generic radix
// Progress used elsewhere in the admin panel.
export const UploadProgressCard = ({ percent, loaded, total, speedBps, fileCount }) => {
  const etaSeconds = speedBps > 0 && total > loaded ? (total - loaded) / speedBps : null;

  return (
    <div
      data-testid={PATCHES_ADMIN.progressBar}
      className="mt-4 overflow-hidden rounded-xl border border-[#F0801F]/30 bg-gradient-to-br from-[#1c1c21] to-[#141417] p-5 shadow-[0_0_40px_rgba(240,128,31,0.15)]"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F0801F] opacity-75" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F0801F]" />
          </span>
          <p className="font-display text-xs font-600 uppercase tracking-[0.16em] text-white/70">
            Nahrávám {fileCount > 1 ? `${fileCount} souborů` : "soubor"}…
          </p>
        </div>
        <span className="font-display text-2xl font-600 tabular-nums text-[#F0801F]">{percent}%</span>
      </div>

      <div className="relative mt-4 h-3 w-full overflow-hidden rounded-full bg-white/[0.06]">
        <motion.div
          className="relative h-full rounded-full bg-gradient-to-r from-[#F0801F] to-[#ffb066] shadow-[0_0_12px_rgba(240,128,31,0.6)]"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ type: "spring", stiffness: 90, damping: 22 }}
        >
          <div className="absolute inset-0 animate-shimmer bg-[length:200%_100%] bg-[linear-gradient(110deg,transparent_40%,rgba(255,255,255,0.45)_50%,transparent_60%)]" />
        </motion.div>
      </div>

      <div className="mt-2.5 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs text-white/40">
        <span className="tabular-nums">
          {formatBytes(loaded)} / {formatBytes(total)}
        </span>
        <span className="tabular-nums">
          {speedBps > 0 && `${formatBytes(speedBps)}/s`}
          {etaSeconds !== null && ` · zbývá ${formatDuration(etaSeconds)}`}
        </span>
      </div>
    </div>
  );
};
